import React, { Component} from 'react';
import Button from '../../../components/UI/Button/Button'
import classes from './ContactData.css'
import axios from "../../../axios-orders";
import Spinner from "../../../components/UI/Spinner/Spinner";

class ContactData extends Component {
    state = {
        name:'',
        email:'',
        address: {
            street:'',
            postalCode:''
        },
        loading:false
    }
    orderHandler = (event) => {
        event.preventDefault()
        this.setState({loading: true})
        //alert('Purchased, Cooking now! Thank you for your order!')
        const order = {
            ingredients: this.props.ingredients,
            price: this.props.price,
            customer: {
                name : "Finian Simes",
                address: {
                    street: "my street",
                    zipCode: "5555",
                    country: "Aussieland",
                },
                email: 'test@test.com'
            },
            deliveryMethod: 'fastest'
        };
        axios.post('/orders.json', order)
            .then(response => {
                console.log(response)
                this.setState({loading:false})
                this.props.history.push('/')
            })
            .catch(error => {
                console.log(error)
                this.setState({loading:false}
            )})
    }
    render() {
        let form = (
            <form>
                <input className={classes.Input} type="text" name="name" placeholder="Your name"/>
                <input className={classes.Input} type="email" name="email" placeholder="Your email"/>
                <input className={classes.Input} type="text" name="street" placeholder="Your Street"/>
                <input className={classes.Input} type="text" name="postcode" placeholder="Your Postcode"/>
                <Button clicked={this.orderHandler} btnType="Success">Order</Button>
            </form>
        );
        if (this.state.loading){
            form = <Spinner/>
        }
        return (
          <div className={classes.ContactData}>
              <h4>Enter your Contact Data</h4>
              {form}
          </div>
        );
    }

}

export default ContactData


// WEBPACK FOOTER //
// ./src/containers/Checkout/ContactData/ContactData.js